let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ct3kN"), load("7Xau5")]).then(() => parcelRequire('aUago'));